import { createSlice } from '@reduxjs/toolkit';

const payoutSettingSlice = createSlice({
  name: 'payoutSettingSlice',
  initialState: {
    isLoading: false,
    isViewLoading: false,
    isStripeAccountsLoading: false,
    payoutSettingList: [],
    viewPayoutSetting: null,
    stripeAccounts: { platformAccounts: [], connectedAccounts: [] },
    isError: null,
  },
  reducers: {
    /////// List ///////
    requestPayoutSettingList: (state) => {
      return { ...state, isLoading: true };
    },
    responsePayoutSettingList: (state, action) => {
      return {
        ...state,
        isLoading: false,
        payoutSettingList: action?.payload?.data || [],
      };
    },
    failurePayoutSettingList: (state, action) => {
      return { ...state, isLoading: false, isError: action?.payload };
    },

    /////// Create ///////
    requestPayoutSettingCreate: (state) => {
      return { ...state, isLoading: true };
    },
    responsePayoutSettingCreate: (state) => {
      return { ...state, isLoading: false };
    },
    failurePayoutSettingCreate: (state, action) => {
      return { ...state, isLoading: false, isError: action?.payload };
    },

    /////// Toggle ///////
    requestPayoutSettingToggle: (state) => {
      return { ...state, isLoading: true };
    },
    responsePayoutSettingToggle: (state, action) => {
      const updated = action?.payload?.data;
      return {
        ...state,
        isLoading: false,
        payoutSettingList: state.payoutSettingList.map((item) =>
          item.id === updated?.id
            ? { ...item, isActive: updated.isActive }
            : item,
        ),
      };
    },
    failurePayoutSettingToggle: (state, action) => {
      return { ...state, isLoading: false, isError: action?.payload };
    },

    /////// Delete ///////
    requestPayoutSettingDelete: (state) => {
      return { ...state, isLoading: true };
    },
    responsePayoutSettingDelete: (state, action) => {
      return {
        ...state,
        isLoading: false,
        payoutSettingList: state.payoutSettingList.filter(
          (item) => item.id !== action?.payload,
        ),
      };
    },
    failurePayoutSettingDelete: (state, action) => {
      return { ...state, isLoading: false, isError: action?.payload };
    },

    /////// View (single) ///////
    requestPayoutSettingView: (state) => {
      return { ...state, isViewLoading: true, viewPayoutSetting: null };
    },
    responsePayoutSettingView: (state, action) => {
      return {
        ...state,
        isViewLoading: false,
        viewPayoutSetting: action?.payload?.data || null,
      };
    },
    failurePayoutSettingView: (state, action) => {
      return { ...state, isViewLoading: false, isError: action?.payload };
    },

    /////// Edit ///////
    requestPayoutSettingEdit: (state) => {
      return { ...state, isLoading: true };
    },
    responsePayoutSettingEdit: (state) => {
      return { ...state, isLoading: false };
    },
    failurePayoutSettingEdit: (state, action) => {
      return { ...state, isLoading: false, isError: action?.payload };
    },

    /////// Stripe Accounts ///////
    requestStripeAccounts: (state) => {
      return { ...state, isStripeAccountsLoading: true };
    },
    responseStripeAccounts: (state, action) => {
      return {
        ...state,
        isStripeAccountsLoading: false,
        stripeAccounts: action?.payload?.data || {
          platformAccounts: [],
          connectedAccounts: [],
        },
      };
    },
    failureStripeAccounts: (state, action) => {
      return {
        ...state,
        isStripeAccountsLoading: false,
        isError: action?.payload,
      };
    },
  },
});

export const {
  requestPayoutSettingDelete,
  responsePayoutSettingDelete,
  failurePayoutSettingDelete,
  requestPayoutSettingList,
  responsePayoutSettingList,
  failurePayoutSettingList,
  requestPayoutSettingCreate,
  responsePayoutSettingCreate,
  failurePayoutSettingCreate,
  requestPayoutSettingToggle,
  responsePayoutSettingToggle,
  failurePayoutSettingToggle,
  requestPayoutSettingView,
  responsePayoutSettingView,
  failurePayoutSettingView,
  requestPayoutSettingEdit,
  responsePayoutSettingEdit,
  failurePayoutSettingEdit,
  requestStripeAccounts,
  responseStripeAccounts,
  failureStripeAccounts,
} = payoutSettingSlice.actions;

export default payoutSettingSlice.reducer;
